export const secureUploadOTPRoute = {
  path: '/secure-upload',
  name: 'secure-upload',
  component: () => import(/* webpackChunkName: "SecureUpload" */ '../../components/SecureUpload/SecureUploadVerifyForm.vue'),
  props: () => ({ isSecureUploadLogin: true }), // ✅ Use a function
  meta: { publicRoute: true },
}
